/* eslint-disable security/detect-object-injection */ // Gender Affinity Count
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
export var calculateGenderAffinityFromCounts = function(counts) {
    // timestamp is a key on the counts object but we ignore it as an affinity
    var timestamp = counts.timestamp, affinities = _object_without_properties_loose(counts, [
        "timestamp"
    ]);
    // Find the top count number
    var topCount = Object.values(affinities).reduce(function(top, count) {
        return top >= count ? top : count;
    }, 0);
    // Find the affinities at the top count
    var topAffinities = Object.keys(affinities).filter(function(affinity) {
        return affinity !== "all" && counts[affinity] === topCount;
    });
    // length 0 meant all was the top
    // length 2 meant both men and women were equal
    return topAffinities.length === 1 ? topAffinities[0] : "all";
};
// This is for Activity, Collection, Color and Category Affinity
export var calculateTopAffinityFromCounts = function(counts) {
    // timestamp is a key on the counts object but we ignore it as an affinity
    var timestamp = counts.timestamp, affinities = _object_without_properties_loose(counts, [
        "timestamp"
    ]);
    // Find the top count number
    var topCount = Object.values(affinities).reduce(function(top, count) {
        return top >= count ? top : count;
    }, 0);
    // Find the affinities at the top count
    var topAffinities = Object.keys(affinities).filter(function(affinity) {
        return counts[affinity] === topCount;
    });
    // Since there are batch updates, it's impossible to determine what
    // was the most recently incremented affinity. So when there are
    // multiple at the top count we just take the first one lexicographically.
    return topAffinities.length === 0 ? "unknown" : topAffinities.sort()[0];
};
